import { OrganizationKeyName } from "../../model/Organization";
import { PlanListItem } from "../../service/api-response/PlanListSuccessResponse";
import { Subscription } from "../../service/api-response/SubscriptionsSuccessResponse";
import { RootState } from "../../store";

const arr: any = [];

export const isLoadingSubscriptionsForUser = (
  state: RootState,
  org: OrganizationKeyName,
  userId: number
): boolean => {
  return !!state.subscription.isLoadingSubscriptions[userId];
};

export const subscriptionsForUser = (
  state: RootState,
  org: OrganizationKeyName,
  userId: number
): Subscription[] => {
  const subscriptions = state.subscription.subscriptions[userId];
  return subscriptions || arr;
};

export const isLoadingPlansForOrganization = (
  state: RootState,
  org: OrganizationKeyName
): boolean => {
  return !!state.subscription.isLoadingPlans[org];
};

export const plansForOrganization = (
  state: RootState,
  org: OrganizationKeyName
): PlanListItem[] => {
  const plans = state.subscription.plans[org];
  return plans || arr;
};
